<template>
  <with-actions>
    <p class="mb-0 text-muted">
      <span>{{ 'found' | t }} {{ order_channels.length }}</span
      ><span class="pl-1" v-if="order_channels.length === 1">{{ 'order_channel' | t }}</span
      ><span class="pl-1" v-else>{{ 'order_channels' | t }}</span>
    </p>
    <lazy-table ref="table" v-model="order_channels" model="order_channel_indexes" :params="query" :autoload="false">
      <order-channel-filters @change="updateQuery" slot="header"></order-channel-filters>
      <div class="m-3 mt-4">
        <table class="table table-hover table-responsive w-100 d-block d-md-table">
          <thead>
            <tr>
              <th>{{ 'order_channel' | t | titlecase }}</th>
              <th>{{ 'order_channel_type' | t | titlecase }}</th>
              <th>{{ 'customer' | t | titlecase }}</th>
              <th class="text-right" v-if="can('write_customer_tokens')">{{ 'impersonate' | t }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="channel in order_channels" :key="channel.id">
              <router-link
                class="pointer"
                :to="{ name: 'customers_show', params: { customer_id: channel.customer.id } }"
                tag="td"
                >{{ channel.name }}</router-link
              >
              <router-link
                class="pointer"
                :to="{ name: 'order_channel_type', params: { order_channel_type_id: channel.order_channel_type.id } }"
                tag="td"
                >{{ channel.order_channel_type.name }}</router-link
              >
              <router-link
                class="pointer"
                :to="{ name: 'customers_show', params: { customer_id: channel.customer.id } }"
                tag="td"
                >{{ channel.customer.name }}</router-link
              >
              <td class="text-right" v-if="can('write_customer_tokens')">
                <impersonate-button :tenant="channel.customer.tenant_name"></impersonate-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </lazy-table>
  </with-actions>
</template><script>
export default {
  data() {
    return {
      query: {
        include: 'order_channel_type,customer',
        filter: {}
      },

      order_channels: []
    };
  },

  watch: {
    query: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      }
    }
  },

  methods: {
    updateQuery(q) {
      this.query.filter = q.filter;
    }
  },

  created() {
    this.$store.commit('setBreadcrumbs', [{ to: { name: 'order_channels' }, text: this.$i18n.t('order_channels') }]);
  }
};
</script>

<style scoped>
table.table th,
table.table td {
  border-top: none;
}

.pointer {
  cursor: pointer;
}
</style>
